import React, { useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";
import {loadCreditCards} from "@awe-web/shared/lib";
import {Translation as T} from "@awe-web/shared/lib";

import { useInitialize } from "../../../util/react.js";
import {ScreenSection, ScreenHeading, ScreenLoading} from "../../../components/screen.js";
import {TypeArea} from "../../../components/layout.js";
import {Row, Col} from "../../../components/grid.js";
import {CreditCardsFieldset} from "../../../user/components/form.js";
import {getCreditCardsEnabled} from "../../../config/store.js";

const PAYMENT_METHODS_HEADING = "FSD0000307";
const PAYMENT_METHODS_DISABLED = "ALG0000264";

export default function MyBmwRentPaymentMethods() {
  const dispatch = useDispatch();

  const creditCardsEnabled = useSelector((state) => getCreditCardsEnabled(state));

  const init = useCallback(async () => {
    await dispatch(loadCreditCards());
  }, [dispatch]);

  const isReady = useInitialize(init);
  if (!isReady) {
    return <ScreenLoading />;
  }

  return (
    <div>
      <ScreenSection main dark>
        <TypeArea>
          <Row>
            <Col desktop={{cols: 8, offset: 2}}>
              <ScreenHeading><T code={PAYMENT_METHODS_HEADING} /></ScreenHeading>
            </Col>
          </Row>
          {creditCardsEnabled
            ? (
              <CreditCardsFieldset/>
            )
            : (
              <Row>
                <Col desktop={{cols: 8, offset: 2}}>
                  <div><T code={PAYMENT_METHODS_DISABLED} /></div>
                </Col>
              </Row>
            )}
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
